class CookieBanner extends HTMLElement {
  constructor() {
    super();
    // Select elements
    this.cookieBannerClose = this.querySelector('.js-cookie-banner-close');
    this.allowAllButtons = this.querySelectorAll('.js-allow-all');
    this.allowPreferenceButton = this.querySelector('.js-allow-preference');
    this.confirmOptionsButton = this.querySelector('.js-confirm-options');

    // Bind event handlers
    this.bindEvents();
  }

  bindEvents() {
    if (this.cookieBannerClose) {
      this.cookieBannerClose.addEventListener('click', () => {
        this.hideBanner();
      });
    }

    if (this.allowAllButtons) {
      this.allowAllButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.handleAllowAll();
        });
      });
    }

    if (this.allowPreferenceButton) {
      this.allowPreferenceButton.addEventListener('click', () => {
        this.showPreferences();
      });
    }

    if (this.confirmOptionsButton) {
      this.confirmOptionsButton.addEventListener('click', () => {
        this.handleConfirmPreferences();
      });
    }
  }

  handleAllowAll() {
    const preferences = {
      preferences: true,
      analytics: true,
      marketing: true,
    };

    // Update Shopify preferences
    window.Shopify.customerPrivacy.setTrackingConsent(preferences);

    // Update Google Consent Mode
    this.updateGoogleConsent(preferences);

    this.hideBanner();
  }

  handleConfirmPreferences() {
    const preferences = this.getPreferencesFromToggles();

    // Update Shopify preferences
    window.Shopify.customerPrivacy.setTrackingConsent(preferences);

    // Update Google Consent Mode
    this.updateGoogleConsent(preferences);

    this.hideBanner();
  }

  getPreferencesFromToggles() {
    const toggles = this.querySelectorAll('.cookie-banner__preference__item input[type="checkbox"]');
    const preferences = {
      preferences: false,
      analytics: false,
      marketing: false,
    };

    toggles.forEach((toggle) => {
      const id = toggle.id;
      if (id === 'analytics') preferences.analytics = toggle.checked;
      if (id === 'preferences') preferences.preferences = toggle.checked;
      if (id === 'marketing') preferences.marketing = toggle.checked;
    });

    return preferences;
  }

  updateGoogleConsent(preferences) {
    const consent = {
      ad_storage: preferences.marketing ? 'granted' : 'denied',
      analytics_storage: preferences.analytics ? 'granted' : 'denied',
      functionality_storage: preferences.preferences ? 'granted' : 'denied',
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'updateConsent',
      consent,
    });

    console.log('Google Consent updated:', consent);
  }

  showPreferences() {
    this.classList.add('preference');
  }

  hideBanner() {
    this.classList.add('hidden');
  }

  setInitialPreferences() {
    const consent = window.Shopify.customerPrivacy.currentVisitorConsent();
    if (consent) {
      this.querySelector('#analytics').checked = consent.analytics === 'yes';
      this.querySelector('#preferences').checked = consent.preferences === 'yes';
      this.querySelector('#marketing').checked = consent.marketing === 'yes';
    }
  }

  handleBannerVisibility() {
    const shouldShow = window.Shopify.customerPrivacy.shouldShowBanner();
    const consent = window.Shopify.customerPrivacy.currentVisitorConsent();

    const hasUnsetConsent =
      consent && (consent.analytics === '' || consent.marketing === '' || consent.preferences === '');

    if (shouldShow && hasUnsetConsent) {
      this.classList.remove('hidden');
    } else {
      this.classList.add('hidden');
    }
  }

  connectedCallback() {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          console.error('Error loading consent-tracking-api:', error);
          return;
        }

        this.setInitialPreferences();
        this.handleBannerVisibility();
      }
    );
  }

  disconnectedCallback() {
    // Cleanup if necessary
  }
}

customElements.define('cookie-banner', CookieBanner);